import {Observable} from "rxjs/Observable";
import {appInjector} from "../../../index";
import {SessionActions} from "../../../shared/actions/session.actions";
import {isApolloError} from "apollo-client/errors/ApolloError";
import {delay, finalize, retryWhen, scan, tap} from "rxjs/operators";
import {ApolloQueryResult} from "apollo-client";

/**
 * Created by afuhr on 31.12.2016.
 */

export const handleObservable = <R>(finalErrorMessage?: string) => <T>(source: Observable<T>) => {
  let sessionActions: SessionActions = appInjector().get(SessionActions);
  return source.pipe(
    retryWhen(errors => errors.pipe(
      tap(e => { // Don't retry when ApolloError occured!
          if (isApolloError(e) && e.graphQLErrors && e.graphQLErrors.length > 0) {
            throw e;
          }
        }
      ),
      scan<number>((errorCount, err) => {
        console.warn("Retry fetching observable #" + errorCount, [err]);
        if (errorCount >= 5) {
          throw err;
        }
        return errorCount + 1;
      }, 0),
      delay(500)
      )
    ),
    finalize(() => {
      if (sessionActions) {
        sessionActions.finishAsyncAction();
      }
    })
  );
};

/**
 * The interface is required for TypeScript to recognize the new operator
 */
/*
export interface HandleObservableSignature<T> {
  <R>(finalErrorMessage?: string): Observable<R>;
}

declare module 'rxjs/Observable' {
  interface Observable<T> {
    handleObservable: HandleObservableSignature<T>;
  }
}
*/

export function observableResult<T>(): Observable<T> {
  return this;
}

export interface ObservableResultSignature<T> {
  (): Observable<T>;
}

declare module 'rxjs/Observable' {
  interface Observable<T> {
    observableResult: ObservableResultSignature<T>;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/graphql/handleObservable.ts